import script from "./VoiceCallTriggerCard.vue?vue&type=script&setup=true&lang=js"
export * from "./VoiceCallTriggerCard.vue?vue&type=script&setup=true&lang=js"

import "./VoiceCallTriggerCard.vue?vue&type=style&index=0&id=73d05f15&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73d05f15"]])

export default __exports__